import BrowserstackInterviewPrepSDE from "./browserstack";
import N8nSetupArticle from "./n8n-setup-docker-ngrok";
import NgrokTutorialCompleteGuideforHackersDevelopers from "./new";
import BuildingaprojectinAngular from "./building-a-project-in-angular";

export const ArticleComponents = {
  N8nSetupArticle,
  NgrokTutorialCompleteGuideforHackersDevelopers,
  BrowserstackInterviewPrepSDE,
  BuildingaprojectinAngular,
};
